import { Button } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Swal from "sweetalert2";

export const CopyModal = ({
    open,
    onClose,
    classCode,
}: {
    open: boolean;
    onClose: () => void;
    classCode: string;
}) => {
    const textTemplate = `1. 請同學點擊連結進入翰林AI寫作批改\n${" ".repeat(
        4
    )}https://chaiwriting-h.hle.com.tw/\n2. 登入教育雲或翰林帳號\n3. 點擊【加入班級】\n4. 輸入班級邀請碼：${classCode}`;
    return (
        <div
            onClick={onClose}
            className={`fixed top-0 left-0 right-0 bottom-0 bg-black/50 flex items-center justify-center z-20 p-4 ${open ? "block" : "hidden"
                }`}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className="bg-white px-6 py-6 md:px-20 md:py-10 rounded-lg flex flex-col gap-4 w-full max-w-[600px] max-h-[90vh] overflow-y-auto items-center"
            >
                <div className="flex items-center justify-center p-4 bg-primary-light text-lg font-medium text-white rounded-sm w-full">
                    請複製以下說明，並發送給學生
                </div>
                <div className="bg-primary-light/15 border-primary-light/50 border-2 p-4 rounded-sm flex flex-col gap-y-2 w-full">
                    <span className="text-lg font-medium text-center"></span>
                    <span className="flex flex-col">
                        <span>1. 請同學點擊連結進入翰林AI寫作批改</span>
                        <a
                            href="https://chaiwriting-h.hle.com.tw/"
                            target="_blank"
                            className="ml-[1em] text-primary-light break-all"
                        >
                            https://chaiwriting-h.hle.com.tw/
                        </a>
                    </span>
                    <span>2. 登入教育雲或翰林帳號</span>
                    <span>3. 點擊【加入班級】</span>
                    <span>4. 輸入班級邀請碼：{classCode}</span>
                    <Button
                        sx={{
                            width: "fit-content",
                            px: "24px",
                            py: "8px",
                            alignSelf: "center",
                            mt: "1em",
                        }}
                        variant="contained"
                        startIcon={<ContentCopyIcon />}
                        onClick={() => {
                            navigator.clipboard.writeText(textTemplate);
                            Swal.fire({
                                icon: "success",
                                title: "複製成功",
                                timer: 1500,
                                showConfirmButton: false,
                            });
                            onClose();
                        }}
                    >
                        複製說明
                    </Button>
                </div>
            </div>
        </div>
    );
};